module.exports = __webpack_public_path__ + "static/media/image10a.5eb6870b.png";